import { UserProfile } from './types';
import { supabase } from '../lib/supabase';
import { Dispatch } from 'redux';
import { setUpdateUserProfily } from '../redux/reducers/authSlice';

export class PayAPI {
  static async getUserProfiles(user_id: string): Promise<UserProfile | null>{
    const { data, error } = await supabase
      .from('user_profiles')
      .select('*')
      .eq('id', user_id)
      .single();
    if (error) return null;
    return data;
  }
  static async modifyCoins(
    dispatch: Dispatch,
    update_coin: number,
  ): Promise<UserProfile | null | string> {
    try {
      const { data: user } = await supabase.auth.getUser();
      if (!user.user) return null;

      const data = await this.getUserProfiles(user.user.id);
      if(!data) throw new Error("Not found user");
      if(data.coins + update_coin < 0) return "not-coins";

      const { data: up_data, error: up_err } = await supabase
        .from('user_profiles')
        .update({ coins: data.coins + update_coin })
        .eq('id', user.user.id)
        .select()
        .single();
      if (up_err) throw up_err;
      dispatch( setUpdateUserProfily(up_data) )
      return up_data;
    } catch (err: any) {
      console.error('Failed to get current user:', err.message);
      return null;
    }
  };
  
  static async modifyPhoneTime(
    update_time: number,
  ): Promise<UserProfile | null | string> {
    try {
      const { data: user } = await supabase.auth.getUser();
      if (!user.user) return null;

      const data = await this.getUserProfiles(user.user.id);
      if(!data) throw new Error("Not found user");

      const { data: up_data, error: up_err } = await supabase
        .from('user_profiles')
        .update({ phone_time: data.phone_time + update_time })
        .eq('id', user.user.id)
        .select().single();
      if (up_err) throw up_err;
      return up_data;
    } catch (err: any) {
      console.error('Failed to get current user:', err.message);
      return null;
    }
  };

  static async updateProfiles(
    dispatch: Dispatch,
    newData: {[key:string]: any}
  ){
    try {
      const { data: user } = await supabase.auth.getUser();
      if (!user.user) return null;
      const { data, error } = await supabase
        .from('user_profiles')
        .update(newData)
        .eq('id', user.user.id)
        .select()
        .single();
      if (error) throw error;
      dispatch( setUpdateUserProfily(data) )
      return data;
    } catch (err) {
      console.error('Failed to get current user:', err);
      return null;
    }
  }

  static async getPlanUrl(
    price_id: string, mode: "subscription" | "payment"
  ): Promise<{url: string} | null>{

    // price_1RDbCGK9oh0lFlzBKGKqpHZY // weekly
    // price_1RDbp7K9oh0lFlzBaACkNplh // month
    // price_1RE5cFK9oh0lFlzBAcNS6TWa // 3000
    // price_1RE5d1K9oh0lFlzBA1fLxUWT // 10000

    // test:

    // price_1RE5xhK9oh0lFlzBs6aveuVE // weekly
    // price_1RE5y2K9oh0lFlzBZeJlW2MP // month
    // price_1RE5ygK9oh0lFlzBqu1D7CNm // 3000
    // price_1RE5zBK9oh0lFlzBJVPoZAhm // 10000
    try {
      const { data: user } = await supabase.auth.getUser();
      if (!user.user) return null;
      let redirect_url = window.location.origin;
      const { data, error } = await supabase.functions.invoke('stripe-url', {
        body: { price_id, user_id: user.user.id, mode, redirect_url },
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
          'Access-Control-Allow-Headers': 'Content-Type, Authorization'
        }
      })
      return data;
    } catch (err) {
      console.error('Failed to get plan id:', err);
      return null;
    }
  }
  
}